import { useMutation } from 'react-query';
import {
  getDiscoveredHomeAssistantEntitiesAsync,
  getAllHomeAssistantDevicesByLicenseAsync,
  linkHomeAssistantDeviceAsync,
  triggerHomeAssistantDeviceAsync,
  triggerHomeAssistantGroupAsync,
} from '../..';

export const useGetDiscoveredHomeAssistantEntitiesAsync = () =>
  useMutation(getDiscoveredHomeAssistantEntitiesAsync);

export const useGetAllHomeAssistantDevicesByLicenseAsync = () =>
  useMutation(getAllHomeAssistantDevicesByLicenseAsync);

export const useLinkHomeAssistantDeviceAsync = () =>
  useMutation(linkHomeAssistantDeviceAsync);

export const useTriggerHomeAssistantDeviceAsync = () =>
  useMutation(triggerHomeAssistantDeviceAsync);

export const useTriggerHomeAssistantGroupAsync = () =>
  useMutation(triggerHomeAssistantGroupAsync);
